import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { AppLargeFooterFragmentDoc } from './AppLargeFooter.generated';
export type AppFooterFragment = { __typename?: 'Query', terms: Array<{ __typename?: 'TermRevision', type: Types.TermType, title: string }> };

export const AppFooterFragmentDoc = gql`
    fragment AppFooter on Query {
  ...AppLargeFooter
}
    ${AppLargeFooterFragmentDoc}`;